import React, { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { DesignProjectTileBgImage } from './DesignProjectTileBgImage';
import { DesignProjectTileDetails } from './DesignProjectTileDetails';
import { DESIGN_PROJECT_STATUS_ACTIVE } from '../../constants';

import styles from './DisplayDesignProjectTile.scss';

import { DisplayDesignProjectTile_designProject } from './__generated__/DisplayDesignProjectTile_designProject.graphql';

type Props = {
    designProject: DisplayDesignProjectTile_designProject | null;
};

const DisplayDesignProjectTileComponent: FC<Props> = ({ designProject }) => {
    if (!designProject || designProject.status !== DESIGN_PROJECT_STATUS_ACTIVE) {
        return null;
    }

    return (
        <div className={`${styles.container} colXs6 colMd6 colXl3`}>
            <a
                className={styles.innerContainer}
                href={designProject.url || ''}
                data-tn="design-project-tile-project-link"
            >
                <DesignProjectTileBgImage coverPhotoPath={designProject.coverPhoto} />
                <div className={styles.detailsWrapper}>
                    <DesignProjectTileDetails
                        addressDisplayString={designProject.addressDisplayString}
                        name={designProject.name}
                    />
                </div>
            </a>
        </div>
    );
};

export const DisplayDesignProjectTile = createFragmentContainer(DisplayDesignProjectTileComponent, {
    designProject: graphql`
        fragment DisplayDesignProjectTile_designProject on DesignProjectCover {
            serviceId
            addressDisplayString
            name
            rootId
            status
            coverPhoto
            url
        }
    `,
});
